export const vitals = {
  healthyReading: '¡No se detectaron anomalías!',
  unhealthyReading: 'Tus signos vitales pueden estar fuera del rango normal.',
  errorReading: 'No se pueden verificar tus signos vitales, por favor inténtalo de nuevo.',
  keepFaceInside: 'Por favor, mantén tu rostro dentro del círculo...',
  stress: 'Estrés',
  heartRate: 'Frecuencia cardíaca',
  oxygen: 'Oxígeno',
  bloodPressure: 'Presión arterial',
  respiratoryRate: 'Frecuencia respiratoria',
  recordedOnToday: 'Grabado hoy a las {{ time }}',
  recordedOn: 'Grabado hoy a las {{ time }}',
  disclaimerTitle: 'Descargo de responsabilidad del verificador de signos vitales',
  scanning: 'Escaneo en progreso',
  pleaseEnsureYourFace: 'Por favor, asegúrate de que tu cara ocupe la mayor parte de la vista de la cámara',
  pleaseKeepStill: 'Por favor, mantente quieto',
  needAssistance: '¿Necesitas ayuda?',
  feelFreeToContactPrime: '¡No dudes en contactar a tu equipo Prime',
  disclaimer1:
    'Esta tecnología no es un dispositivo médico. Está destinada a ayudarte a ser más consciente de tu salud y bienestar. No afirmamos diagnosticar, minimizar, prevenir o tratar ninguna enfermedad, trastorno, síntoma o estado físico inusual.',
  disclaimer2:
    'Esta herramienta es solo para fines de detección y no debe reemplazar los signos vitales o exámenes en persona cuando sea necesario.',
  history: 'Historia',
  whoUsingScanner: '¿Quién está usando el escáner hoy?',
  actions: {
    moreOptions: 'Más opciones',
    finish: 'Finalizar y regresar a Inicio',
    checkAgain: 'Revisar de nuevo',
    viewHistory: 'Ver historial',
    checkMySymptoms: 'Revisar mis síntomas',
    contactForSupport: 'Contactar para soporte',
    cancel: 'Cancelar',
    moreInfoAccuracy: 'Más información sobre la precisión del verificador de signos vitales',
    callUs: 'Llámanos',
  },
};
